import React from "react";
import { Snackbar, Alert } from "@mui/material";
import { observer } from "mobx-react";
import { useRootStore } from "../../store/contexts";

export const GlobalSnackbar: React.FC = observer(() => {
  const rootStore = useRootStore();

  const handleClose = (_event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === "clickaway") {
      return;
    }
    rootStore.closeSnackbar();
  };

  // Errors persist until manually closed, other severities auto-hide after 4s
  const autoHideDuration = rootStore.snackbarSeverity === "error" ? null : 4000;

  return (
    <Snackbar
      open={rootStore.snackbarOpen}
      autoHideDuration={autoHideDuration}
      onClose={handleClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
    >
      <Alert
        onClose={handleClose}
        severity={rootStore.snackbarSeverity}
        variant="filled"
        sx={{ width: "100%" }}
      >
        {rootStore.snackbarMessage}
      </Alert>
    </Snackbar>
  );
});
